import React from 'react'
import * as Layout from '../../components/layout'
import * as Menu from '../../components/menu'

export const routes = [
  {
    action: () => import(/* webpackChunkName: "MemberDetails" */'./component')
      .then(({ MemberDetailsConnected }) => <Layout.Layout><MemberDetailsConnected /></Layout.Layout>),
    path: `${Menu.SUBSCRIBERS_SUBSCRIBER_DETAIL_URL}/:memberIdentifier`,
  },
]



// WEBPACK FOOTER //
// ./src/pages/member-details/routes.tsx